import AdvancedSearch from "../../js/advancedSearch";
import { reactive, getCurrentInstance, ref, toRaw } from "vue";

export default function useAdvancedSearch() {

  const internalInstance = getCurrentInstance();
  const global = internalInstance.appContext.config.globalProperties;
  const advancedSearchInstance = new AdvancedSearch(global.$searchFields.sourceFields);

  const {
    fields,
    fieldOpts,
    boolOpts,
    inputGroups,
    addInputGroup,
    removeInputGroup,
    updateInputGroup,
    parseQueryString,
    makeQueryString
  } = advancedSearchInstance;

  // inputGroups needs to be in an object to be reactive to changes
  const advSearchRefs = reactive({
    fields: fields,
    fieldOpts: fieldOpts,
    boolOpts: boolOpts,
    inputGroups: inputGroups
  });

  // need to refresh from class here to make changes reactive
  function refreshInputGroups() {
    advSearchRefs.inputGroups = [...advancedSearchInstance.inputGroups];
  }

  const addInputGroupRefresh = () => {
    addInputGroup();
    refreshInputGroups();
  }

  const updateInputGroupRefresh = (group) => {
    updateInputGroup(group);
    refreshInputGroups();
  }

  const removeInputGroupRefresh = (idx) => {
    removeInputGroup(idx);
    refreshInputGroups();
  }

  const parseQueryStringRefresh = (str) => {
    parseQueryString(str);
    refreshInputGroups();
  }

  return {
    advSearchRefs,
    addInputGroup: addInputGroupRefresh,
    parseQueryString: parseQueryStringRefresh,
    removeInputGroup: removeInputGroupRefresh,
    updateInputGroup: updateInputGroupRefresh,
    makeQueryString
  }
}